import React from 'react';
import { AlertTriangle } from 'lucide-react';

const Privacy = () => {
  return (
    <div className="pt-20 bg-gray-900">
      {/* Critical Alert Banner */}
      <div className="bg-red-800 text-white py-3 sticky top-20 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-center text-center text-sm sm:text-base">
            <AlertTriangle className="h-4 w-4 mr-2 flex-shrink-0" />
            <p className="font-semibold">
              CRITICAL: Fewer than 10 vaquitas remain. Extinction expected within months without immediate action.
            </p>
          </div>
        </div>
      </div>

      <div className="min-h-screen bg-gray-900 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <h1 className="text-4xl font-bold text-white mb-8">Privacy Policy</h1>
          
          <div className="space-y-8 text-gray-300">
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Information We Collect</h2>
              <p className="mb-4">
                Fight for Vaquita is committed to protecting your privacy. We collect minimal information necessary to operate our website and support our conservation mission:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Basic website analytics (page views, visit duration)</li>
                <li>Contact information when you voluntarily provide it</li>
                <li>Information submitted through forms or contact methods</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">How We Use Information</h2>
              <p className="mb-4">Any information collected is used solely for:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Improving our website and educational resources</li>
                <li>Responding to inquiries and collaboration requests</li>
                <li>Sharing updates about vaquita conservation efforts</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Data Sharing</h2>
              <p>
                We do not sell, rent, or share personal information with third parties except as necessary to fulfill our educational and conservation mission, or as required by law.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Cookies</h2>
              <p>
                Our website may use cookies to enhance user experience and gather basic analytics. These help us understand how visitors interact with our content.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Third-Party Services</h2>
              <p className="mb-4">Our website may link to external resources including:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Google Scholar for academic research</li>
                <li>Conservation organization websites</li>
                <li>Social media platforms</li>
                <li>Educational and scientific databases</li>
              </ul>
              <p className="mt-4">
                These external sites have their own privacy policies and terms of use.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Contact Us</h2>
              <p>
                Questions about this privacy policy? Contact us at{' '}
                <a href="mailto:contact@fightforvaquita.org" className="text-blue-400 hover:text-blue-300">
                  contact@fightforvaquita.org
                </a>
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Updates</h2>
              <p>
                This privacy policy may be updated periodically. Changes will be posted on this page with the updated date.
              </p>
              <p className="text-sm text-gray-400 mt-4">
                Last updated: January 2025
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;